import React, { Component } from 'react';
import { BeatLoader } from 'react-spinners';
import { Line } from 'react-chartjs-2';
import NotificationSystem from 'react-notification-system';
import { _addNotification, _addNotificationError } from "../../../../server/util";
import moment from 'moment';
import { momentLocalizer } from 'react-big-calendar';
var _ = require('lodash');
class CatererOrderTrend extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false
        }
    }
    render() {
        const data = {
            labels: Object.keys(this.props.data.data).map(key => {
                return moment(key, 'YYYYMM').format('MMM')
            }),
            datasets: [
                {
                    data: Object.values(this.props.data.data).map(value => {
                        return value;
                    }),
                    label: 'Orders count',
                    fill: false,
                    lineTension: 0.1,
                    backgroundColor: 'rgb(87, 208, 200)',
                    borderColor: 'rgb(87, 208, 200)',
                    borderCapStyle: 'butt',
                    borderDash: [],
                    borderDashOffset: 0.0,
                    borderJoinStyle: 'miter',
                    pointBorderColor: 'rgb(87, 208, 200)',
                    pointBackgroundColor: '#fff',
                    pointBorderWidth: 5,
                    pointHoverRadius: 5,
                    pointHoverBackgroundColor: 'rgb(87, 208, 200)',
                    pointHoverBorderColor: 'rgba(220,220,220,1)',
                    pointHoverBorderWidth: 2,
                    pointRadius: 1,
                    pointHitRadius: 10,
                }
            ]
        }
        const options = {
            responsive: true,
            maintainAspectRatio: false,
            legend: {
                position: 'top'
            },
            scales: {
                xAxes: [{
                    ticks: {
                        fontSize: 9,
                        min: 0
                    }
                }],
                yAxes: [{
                    ticks: {
                        fontSize: 9,
                        min: 0
                    }
                }]
            },
            plugins: {
                datalabels: {
                    display: true,
                    align: 'bottom',
                    font: { size: '10', weight: 'bold' }
                }
            }
        }
        return (
            <div>
                <NotificationSystem ref="notificationSystem" />
                <div className="col-md-4">
                    <div className='sweet-loading'
                        style={{ position: 'absolute', top: '50%', left: '48%', zIndex: '1000' }}>
                        <BeatLoader
                            size={20}
                            color={'#ea7066'}
                            loading={this.state.loading}
                        />
                    </div>
                    <div className="panel chart-panel">
                        <div className="panel-heading text-center" style={{ padding: '0px' }}>
                            <span className="panel-title" style={{ fontSize: '14px', fontWeight: '600' }}>
                                {'Catrer Orders Trend'}</span>
                            <div className="pull-right">
                                <a href='javascript:void(0)' className="btn-lt" onClick={() => {
                                    this.props.onChangeYear('SUB');
                                }}><i className='fa fa-chevron-circle-left '></i></a>
                                <a href='javascript:void(0)' className="btn-eq" onClick={() => {
                                    this.props.onChangeYear('');
                                }}><i className='fa fa-circle-o'></i></a>
                                <a href='javascript:void(0)' className="btn-gt" onClick={() => {
                                    this.props.onChangeYear('ADD');
                                }} ><i className='fa fa-chevron-circle-right'></i></a>
                            </div>
                            <div>
                                <p className="panel-title" style={{ fontSize: '12px', fontWeight: '600' }}>
                                    {'[Year: ' + this.props.data.currentYear.format('YYYY') + ']'}</p>
                            </div>
                        </div>
                        <div className="panel-body" style={{ padding: '0px' }}>
                            <Line data={data} options={options} />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default CatererOrderTrend


// WEBPACK FOOTER //
// ./src/components/Caterer/Home/dashboard/catrerOrderTrend.jsx